var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 5 } }, [
        _c("h1", { staticClass: "app-title" }, [_vm._v("Solar App")])
      ]),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 13 } },
        [
          _c(
            "el-menu",
            {
              staticClass: "main-nav",
              attrs: {
                "default-active": _vm.getActiveRoute(),
                mode: "horizontal"
              },
              on: { select: _vm.handleSelect }
            },
            [
              _vm.user_has_role(["admin", "sales", "supplier"])
                ? _c("el-menu-item", { attrs: { index: "/orders" } }, [
                    _vm._v("Bestellungen")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "/buildings" } }, [
                _vm._v("Gebäude")
              ]),
              _vm._v(" "),
              _vm.user_is_admin
                ? _c("el-menu-item", { attrs: { index: "/suppliers" } }, [
                    _vm._v("Supplier\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user_is_supplier
                ? _c("el-menu-item", { attrs: { index: "/supplier" } }, [
                    _vm._v("Supplier-Einstellungen\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user_is_admin
                ? _c("el-menu-item", { attrs: { index: "/users" } }, [
                    _vm._v("Benutzer\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user_is_admin || _vm.user_is_supplier
                ? _c("el-menu-item", { attrs: { index: "/wording" } }, [
                    _vm._v("Bezeichnungen")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.user_is_admin
                ? _c("el-menu-item", { attrs: { index: "/settings" } }, [
                    _vm._v("Benutzer-Einstellungen")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 4 } },
        [
          _vm.is_authenticated
            ? _c(
                "el-button",
                {
                  staticClass: "logout-btn",
                  attrs: { type: "info", plain: "", size: "mini" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.logout()
                    }
                  }
                },
                [
                  _vm._v("\n                Abmelden "),
                  _c("i", { staticClass: "el-icon-arrow-right" })
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ae4d219", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae4d219","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/header.vue
// module id = null
// module chunks = 